module.exports = __webpack_public_path__ + "static/media/cardsErrorPayment.6ac7231f.svg";